window.$ = window.jQuery = require('jquery');
require('fancybox')(window.$);
(function($){
    $(document).ready(function(){
        if ($('.js-our-fleet').length > 0) {
            $("a.js-grid-item").fancybox({
                'transitionIn': 'elastic',
                'transitionOut': 'elastic',
                'speedIn': 600,
                'speedOut': 200,
                'overlayShow': true
            });
        }
    });
})(jQuery.noConflict());